module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-list', {
    staticClass: "destination-lists",
    attrs: {
      "modifier": "noborder"
    }
  }, _vm._l((_vm.destinations), function(destination) {
    return _c('person-outline', {
      key: destination.id + destination.type,
      attrs: {
        "thing": destination,
        "tappable": ""
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a282625c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/destination/list.vue
// module id = 555
// module chunks = 0